import React, { useEffect, useState, useRef } from "react";
import classes from "./Login.module.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserRole, login } from "../../redux/actions/auth";
import { AppDispatch } from "../../redux/store";
import {
  setPasswordError,
  selectAuthenticated,
  selectEmailError,
  selectIsAdmin,
  setEmailError,
  selectPasswordError,
} from "../../redux/slices/authSlice";
import { message } from "antd";
import landing from "../../assets/images/Landing.png";
import { Button, Col, Form, Input, Row } from "antd";
import { HiArrowLeft } from "react-icons/hi2";
import { inputs } from "./loginForm";
import logo from "../../assets/images/LightLogo.webp";
import Swal from "sweetalert2";
const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const messageShown = useRef(false);
  const isAuthenticated = useSelector(selectAuthenticated);
  const emailError = useSelector(selectEmailError);
  const passwordError = useSelector(selectPasswordError);
  const isAdmin = useSelector(selectIsAdmin);

  useEffect(() => {
    if (isAuthenticated && !messageShown.current) {
      messageShown.current = true;

      if (isAdmin) {
        navigate("/posts", { replace: true });
        Swal.fire({
          position: "top",
          text: "Welcome Admin!",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        message.success("Ju jeni i kyçur!");
        navigate("/lajmet", { replace: true });
      }
    }
  }, [isAuthenticated, isAdmin, navigate]);

  useEffect(() => {
    // pastro çdo error të vjetër kur hapet login page
    dispatch(setEmailError(null));
    dispatch(setPasswordError(null));
  }, [dispatch]);

  const loginToApp = async () => {
    try {
      await dispatch(login({ email, password }));

      await dispatch(getUserRole(email));
    } catch (error: any) {
      console.log("LOGIN ERROR:", error);

      if (error?.code === "auth/user-not-found") {
        dispatch(setEmailError("Nuk u gjet asnjë llogari me këtë e-mail."));
        dispatch(setPasswordError(null));
        return;
      }

      if (error?.code === "auth/wrong-password") {
        dispatch(setEmailError(null));
        dispatch(setPasswordError("Fjalëkalimi është i gabim."));
        return;
      }

      dispatch(setEmailError(null));
      dispatch(setPasswordError("Email ose fjalëkalim gabim"));
    }
  };

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      console.log("Enter pressed");
      loginToApp();
    }
  }

  const [form] = Form.useForm();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 425);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth > 425 && window.innerWidth <= 768,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 425);
      setIsTablet(window.innerWidth > 425 && window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={classes.mainDiv}>
      <Row>
        <Col span={24} className={classes.backButton}>
          <div
            className={classes.circleButton}
            onClick={() => navigate("/lajmet")}
          >
            <HiArrowLeft fontSize="1.2rem" color="white" />
          </div>
          <div
            style={{ marginBottom: "0" }}
            className={classes.backTitle}
            onClick={() => navigate("/news")}
          >
            <h2>Rikthehu ne faqe</h2>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={14} className={classes.lefLogoColumn}>
          <div className={classes.logoDiv}>
            <div
              style={{
                width: "84%",
                height: "84%",
                position: "relative",
                backgroundImage: `url(${landing})`,
                backgroundSize: "115% auto",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
              className={classes.logoTextDiv}
            >
              <img
                className={classes.brandLogo}
                src={logo}
                alt="Brieffo logo"
              />
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 1,
                }}
              ></div>

              <h3>
                Burim i besueshëm i informacionit për të gjithë shqiptarët
              </h3>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={10} style={{ padding: 0 }}>
          {!isAuthenticated && (
            <div className={classes.LoginDiv}>
              <div
                className={classes.LoginTitle}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "100%",
                  margin: "0 auto",
                  padding: 0,
                }}
              >
                <h1 style={{ margin: 0 }}>
                  Mirë se vini në{" "}
                  <span style={{ color: "#F4BF4E" }}>Brieffo</span>
                </h1>
                <h4 style={{ margin: 0 }}>Vendosni detajet më poshtë</h4>
              </div>
              <Form
                form={form}
                name="login"
                onFinish={loginToApp}
                validateTrigger="onSubmit"
              >
                <Form.Item
                  name="email"
                  label="Email"
                  validateStatus={emailError ? "error" : ""}
                  help={emailError}
                  className={classes.styledInput}
                  style={{ width: "100%" }}
                  {...inputs.email}
                >
                  <Input
                    placeholder="Vendosni email-in tuaj"
                    className={classes.emailInput}
                    onChange={(e) => {
                      setEmail(e.target.value);

                      form.setFields([{ name: "email", errors: [] }]);

                      if (emailError) {
                        dispatch(setEmailError(null));
                      }
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  label="Fjalëkalimi"
                  validateStatus={passwordError ? "error" : ""}
                  help={passwordError}
                  className={classes.styledInput}
                  {...inputs.password}
                  style={{ width: "100%", color: "red" }}
                >
                  <Input.Password
                    placeholder="Vendosni password-in tuaj"
                    className={classes.emailInput}
                    onChange={(e) => {
                      setPassword(e.target.value);

                      form.setFields([{ name: "password", errors: [] }]);

                      if (emailError) {
                        dispatch(setPasswordError(null));
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  style={{ width: "100%", textAlign: "center" }}
                >
                  <Link
                    to={"/password/forgot"}
                    style={{ color: "#40A2DE", fontSize: "1.1rem" }}
                  >
                    Harruat fjalëkalimin?
                  </Link>
                </Form.Item>

                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  style={{ width: "100%" }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    onKeyDown={handleKeyDown}
                  >
                    Kyçuni
                  </Button>
                </Form.Item>
              </Form>

              <div className={classes.footerLogin}>
                <p>
                  Nuk keni llogari?{" "}
                  <Link to="/register" style={{ color: "#40A2DE" }}>
                    Regjistrohuni
                  </Link>
                </p>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default Login;
